import React from 'react';
import { browserHistory } from 'react-router';

import { Form, Button, Space, message, Modal } from 'antd';
import { AntdPageHeader } from '@yuhuinc/ui-library';

import TemplateForm from './Templates/TemplateForm';

import { createTemplate } from './store/actions';
import { getTranslatedString } from 'helpers/i18n';

const saveTemplateErrorText = getTranslatedString(
  'landlordPortal.applicationTemplate.messages.saveTemplate.error'
);

const CreateApplicationTemplate = () => {
  const [applicationTemplateForm] = Form.useForm();

  const redirectToApplicationTemplates = () =>
    browserHistory.push('/companies/application_templates');
  const redirectToApplicationTemplate = (id) =>
    browserHistory.push(
      `/companies/application_templates/${id}/steps/new?flashMessage=Template%20saved%20successfully`
    );

  const handleCancel = () => {
    Modal.confirm({
      title: `${getTranslatedString(
        'landlordPortal.applicationTemplate.modal.applicationCancel.title'
      )}?`,
      content: getTranslatedString(
        'landlordPortal.applicationTemplate.modal.applicationCancel.content'
      ),
      onOk: () => redirectToApplicationTemplates,
      okText: getTranslatedString(
        'landlordPortal.applicationTemplate.modal.applicationCancel.okText'
      ),
      cancelText: getTranslatedString(
        'landlordPortal.applicationTemplate.modal.applicationCancel.cancelText'
      ),
    });
  };

  const handleSaveAsDraft = () => {
    applicationTemplateForm.validateFields().then((values) => {
      createTemplate(values)
        .done(({ application_template }) => redirectToApplicationTemplate(application_template.id))
        .catch((_) => message.error(saveTemplateErrorText));
    });
  };

  return (
    <div className="body" role="main">
      <AntdPageHeader
        onBack={redirectToApplicationTemplates}
        title={getTranslatedString('landlordPortal.applicationTemplate.create')}
      />

      <TemplateForm form={applicationTemplateForm} formName={'create_application_template'}>
        <Space>
          <Button type="primary" onClick={handleSaveAsDraft}>
            {getTranslatedString('landlordPortal.applicationTemplate.actions.save')}
          </Button>
          <Button onClick={handleCancel}>
            {getTranslatedString('landlordPortal.applicationTemplate.actions.cancel')}
          </Button>
        </Space>
      </TemplateForm>
    </div>
  );
};

export default CreateApplicationTemplate;
